<template>
  <div>
    <div style="padding: 10px;" :class="classObject(item.version)">
      <div class="ellipsis">
        模块类型:
        <span :title="item.name">{{item.name}}</span>
      </div>
      <div class="ellipsis">
        模块别名:
        <span :title="item.alias">{{item.alias}}</span>
      </div>
      <div class="ellipsis">
        模块版本:
        <span :title="item.version" >{{item.version}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Module",
  props: {
    item: {
      type: Object,
      required: true,
      default: {}
    },

  },
  computed: {
    classObject(){
      return function(version){
        if(version.indexOf('win')<0){
          return 'aCss'
        }else {
          if(version.indexOf('linux')>0 || version.indexOf('centos')>0 || version.indexOf('ubuntu')>0){
            return 'cCss'
          }else {
            return 'bCss'
          }
          return ''
        }

      }
    }
  }
};
</script>
<style scoped>
.ellipsis{
    /* display: inline; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .aCss{
    background-color: #ffe420;
  }
  .bCss{
     background-color: skyblue;
   }
  .cCss{
  background-color: white;
}
</style>
